enum Locales {
    BR = 'br',
    PT = 'pt',
}

export default Locales
